import { GameCarouselSlide } from './game-carousel.types';
import { Translate } from 'next-translate';
import { getBadgeVariant, getGamesUrl, isGameNew } from '@/utils/games';
import { BaseGameFieldsFragment } from '@cms/graphql/gamesOverviewPage.generated';
import { VideoType } from '@/utils/vimeoVideoUtils';

export const parseGamesToCarouselSlides = (
  games: BaseGameFieldsFragment[],
  t: Translate,
): GameCarouselSlide[] => {
  const parseTags = (tags: ({ name?: string } | string)[], contain: boolean) => {
    return tags
      .map((tag, index) => {
        if (contain) {
          if (index === 3 && tags.length > 3) {
            return {
              children: `+ ${tags.length - 3}`,
            };
          }
          if (index > 3) {
            return null;
          }
        }
        return {
          children: typeof tag === 'string' ? tag : tag.name,
          variant: getBadgeVariant(typeof tag === 'string' ? tag : tag.name),
        };
      })
      .filter(Boolean);
  };

  return games
    .filter(Boolean)
    .filter(game => game.__typename === 'PageGame')
    .map((game): GameCarouselSlide => {
      return {
        tile: {
          title: game.title,
          href: getGamesUrl(game.urlSlug),
          tags: game.gameTagsCollection ? parseTags(game.gameTagsCollection.items, true) : [],
          badges: game.isUpcoming
            ? [{ children: t('common:labels.upcoming'), variant: 'accentBlue' }]
            : game.sys && isGameNew(game.sys.firstPublishedAt)
            ? [{ children: t('common:labels.new'), variant: 'arcticBlue' }]
            : undefined,
          image: {
            src: `${game.mainImage.url}?h=1300`,
            alt: game.mainImage.description || game.mainImage.title || `${game} image`,
          },
        },

        overlay: {
          title: game.title,
          gameSlug: game.urlSlug,
          description: game.summary,
          mainVideo: {
            title: game.mainVideo?.title,
            videoUrl: game.mainVideo?.videoUrl,
            videoType: game.mainVideo?.videoType as VideoType,
          },
          inGameImage: game.inGameImage
            ? {
                src: `${game.inGameImage.url}?w=1920`,
                alt: game.inGameImage.title,
              }
            : { src: `${game.mainImage?.url}?w=1920`, alt: game.mainImage?.title },
          directPlayLink:
            !!game.isGameLive &&
            !game.hasInstallationGuide &&
            game.linkedLaunchedButtonsComponent?.directPlayLink,
          tags: game.gameTagsCollection
            ? parseTags([...game.gameTagsCollection.items, ...(game.platforms || [])], true)
            : [],
        },
      };
    });
};
